import { Component, OnInit } from '@angular/core';

/**
 * 
 * */
@Component({
  selector: 'campfire-dashboard-page',
  templateUrl: './dashboard.page.component.html',
  styleUrls: ['./dashboard.page.component.scss']
})
export class DashboardPageComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = 'https://campfire.rangegroup.com/';
  }
}

